import { Button } from "@portal/components/ui/Button";

export const AccountPopoverButtons = ({
	prequalOnClick,
	withBondRequestOnClick,
}: {
	prequalOnClick: () => void;
	withBondRequestOnClick: () => void;
}) => {
	return (
		<div className="flex flex-col gap-2 p-4">
			<Button
				color="inverse"
				filled
				onClick={prequalOnClick}
				trackingId="account-admin-entry-prequal"
			>
				Prequal
			</Button>
			<Button
				color="inverse"
				filled
				onClick={withBondRequestOnClick}
				trackingId="account-admin-entry-combined"
			>
				With Bond Request
			</Button>
		</div>
	);
};
